import React, { ChangeEvent, CSSProperties, useCallback } from "react";
import * as styles from "./velavu-switch.module.scss";
import { classArr } from "../helper/style-helper";

export interface VelavuSwitchProps {
	style?: CSSProperties;
	className?: string;

	toggled: boolean;
	onChange?: (toggled: boolean) => void;
	label?: string;
	disabled?: boolean;
	stopPropagation?: boolean;
}

export default function VelavuSwitch(props: VelavuSwitchProps) {
	const propsOnChange = props.onChange;
	const onChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			propsOnChange?.(event.target.checked);
		},
		[propsOnChange],
	);

	// Prevent default on click by default to avoid propagating
	// to parent elements (e.g. a row that is also clickable)
	const stopPropagation = props.stopPropagation ?? true;
	const onClickStopPropagation = useCallback(
		(event: React.MouseEvent) => {
			if (stopPropagation && !props.disabled) {
				event.stopPropagation();
			}
		},
		[stopPropagation, props.disabled],
	);

	return (
		<label
			className={classArr(
				styles.label,
				props.label && styles.labelWithText,
				props.disabled && styles.labelDisabled,
				props.className,
			)}
			style={props.style}
			onClick={onClickStopPropagation}
		>
			<input
				className={styles.input}
				type="checkbox"
				checked={props.toggled}
				disabled={props.disabled}
				onChange={onChange}
			/>
			<div
				className={classArr(
					styles.switch,
					props.label && styles.switchPadding,
				)}
			>
				<div className={styles.handle} />
			</div>

			{props.label}
		</label>
	);
}

export function VelavuSwitchDisplay(props: {
	style?: CSSProperties;
	className?: string;
	toggled?: boolean;
	disabled?: boolean;
}) {
	return (
		<div
			className={classArr(
				styles.switch,
				styles.display,
				props.toggled ? styles.displayChecked : styles.displayUnchecked,
				props.disabled && styles.displayDisabled,
				props.className,
			)}
			style={props.style}
		>
			<div className={styles.handle} />
		</div>
	);
}
